import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() == "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getCurrencyConversionData = async (params) => {
  try {
    const response = await api.get("/api/exchangeRate", { params });
    return response.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getLatestCurrencyConversion = async () => {
  try {
    const response = await api.get("/api/exchangeRate/latest");
    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const postManualCurrencyRates = async (payload) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await api.post(
      `/api/exchangeRate/submit`,
      payload,
      config
    );
    return response.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};
